import { UserTagTypes } from '@medflex/shared-types';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useUserProfile = load => {
  const userProfile = useSelector(state => state.superuser);
  const { userProfile: errors = {} } = useSelector(state => state.errors);
  const isLoadingUserProfile = useSelector(
    ({ loading }) => loading.effects.superuser.loadUserProfile,
  );
  const isCreatingNewPermanentLink = useSelector(
    ({ loading }) => loading.effects.superuser.newPermanentLink,
  );
  const isUpdatingContactPage = useSelector(
    ({ loading }) => loading.effects.superuser.editContactPage,
  );
  const isUpdating = useSelector(({ loading }) => loading.effects.superuser.update);
  const dispatch = useDispatch();
  const {
    loadUserProfile,
    createUserProfile,
    update,
    updatePracticeAddress,
    editContactPage,
    updateChatSettings,
    updatePushSettings,
    updatePatientProfile,
    updateSmsSettings,
    newPermanentLink: createNewPermanentLink,
    createTag,
    updateTag,
    deleteTag,
    identifyHubspotUser,
  } = dispatch.superuser;

  useEffect(() => {
    if (load) loadUserProfile();
  }, [load, loadUserProfile]);

  const userTags = useMemo(
    () =>
      userProfile?.attributes?.tags?.reduce((acc, tag) => {
        if (tag.type === UserTagTypes.FORWARDED_CALL) return acc;
        acc[tag.id] = tag;
        return acc;
      }, {}),
    [userProfile?.attributes?.tags],
  );

  const userTagGroups = useMemo(
    () =>
      userProfile?.attributes?.tagGroups?.reduce((acc, tag) => {
        acc[tag.id] = tag;
        return acc;
      }, {}) || [],
    [userProfile?.attributes?.tagGroups],
  );

  return {
    userProfile,
    isLoadingUserProfile,
    isUpdatingContactPage,
    isCreatingNewPermanentLink,
    createNewPermanentLink,
    isUpdating,
    loadUserProfile,
    createUserProfile,
    editContactPage,
    update,
    updatePracticeAddress,
    errors,
    updatePushSettings,
    updatePatientProfile,
    userTags,
    userTagGroups,
    createTag,
    updateTag,
    deleteTag,
    updateSmsSettings,
    identifyHubspotUser,
    updateChatSettings,
  };
};

export default useUserProfile;
